<div class="timer-container">
    <!-- <div class="right-timer-container">
        <button hidden = "true" id = "startTimer{{timerId}}" class="mat-icon-button" (click) = "basicTimer.start();startInitTimer(timerId);">Start</button>
        <ng-container *ngIf = "!hidePause">
            <button id = "pauseTimer{{timerId}}" *ngIf = "showPause" mat-icon-button tooltip = "Pause" placement = "left" (click) = "basicTimer.stop();pauseTimer(timerId)">
                <mat-icon>pause</mat-icon>
            </button>
            <button id = "playTimer{{timerId}}" *ngIf = "showPlay" mat-icon-button tooltip = "Resume" placement = "left" (click) = "basicTimer.resume();resumeTimer(timerId)">
                <mat-icon>play_arrow</mat-icon>
            </button>
        </ng-container>
    </div> -->
    <div class="left-timer-container">    
        <div tooltip = "Timer" placement = "left" class = 'timer-display-container'>
            <cd-timer id = "meetingTimer" [startTime] = 'meetingTimerVal' format="hms" #meetingTimer></cd-timer>
        </div>    
    </div>
</div>